const fortunaStore = {
    CIRCLE_DEG: 360,
    DELAY: 20,
    fields: []
}

function spinWheel() {
    const parent = document.querySelector('.fortuna')

    if (!parent) return

    const ELEMENTS = {
        buttons: parent.querySelectorAll('.Button'),
        spinButtons: parent.querySelectorAll('[data-spin]'),
        bottomSpin: parent.querySelector('.spin'),
        stopSpin: parent.querySelector('.stop'),
        wheel: parent.querySelector('.main-wheel__img-inner'),
    }

    const COMPUTED = {
        rotate: 0,
        step: 9
    }

    ELEMENTS.spinButtons.forEach(button => button.setAttribute('style', 'pointer-events: none;'))

    const intervalStart = setInterval(() => {
        spinner(ELEMENTS.wheel, COMPUTED.rotate)

        COMPUTED.rotate += COMPUTED.step

        if (!(COMPUTED.rotate % (fortunaStore.CIRCLE_DEG * 1))) COMPUTED.step = 12
        else if (!(COMPUTED.rotate % (fortunaStore.CIRCLE_DEG * 2))) COMPUTED.step = 15

    }, fortunaStore.DELAY)

    setTimeout(() => {
        ELEMENTS.stopSpin.removeAttribute('style')
        ELEMENTS.bottomSpin.style = 'display: none;'
    }, 1000)

    ELEMENTS.stopSpin.onclick = () => {
        let randomGift = -(Math.random() * 11).toFixed()
        let isValid = false

        while (!isValid) {
            let checker = 0
            for (let n of fortunaStore.other) {
                if ((randomGift * -1) === n) {
                    randomGift = -(Math.random() * 11).toFixed()
                    checker++
                }
            }
            if (!checker) isValid = true
        }

        const intervalStop = setInterval(() => {
            if (!(COMPUTED.rotate % fortunaStore.CIRCLE_DEG) && COMPUTED.step > 3) {
                COMPUTED.step -= 3
            }

            if (COMPUTED.step <= 3) {
                COMPUTED.step = 0

                fortunaStore.GIFT = {
                    GIFT_UID: randomGift * -1,
                    GIFT_BODY: fortunaStore.fields[randomGift * -1]
                }

                for (let num of fortunaStore.spinAgain) {
                    if (fortunaStore.GIFT.GIFT_UID === num) {
                        ELEMENTS.buttons.forEach(button => button.style = 'display: none;')
                        ELEMENTS.spinButtons.forEach(button => button.removeAttribute('style'))
                        giftsPresent(parent, 'spin-again')
                        clearInterval(intervalStop)
                    }
                }

                clearInterval(intervalStop)
            }

            if (COMPUTED.step <= 3) {
                let newRotate = 1
                const oppositeRotate = fortunaStore.fields.length - (randomGift * -1)
                const giftInterval = setInterval(() => {
                    if (newRotate !== oppositeRotate * 30) {
                        COMPUTED.rotate = newRotate
                        spinner(ELEMENTS.wheel, COMPUTED.rotate)
                        newRotate += 1
                    } else {
                        spinner(ELEMENTS.wheel, COMPUTED.rotate + 1)
                        clearInterval(giftInterval)
                        ELEMENTS.stopSpin.style = 'display: none;'
                        giftsPresent(parent)
                    }
                }, fortunaStore.DELAY / 2)
            }

            spinner(ELEMENTS.wheel, COMPUTED.rotate)

            COMPUTED.rotate += COMPUTED.step
        }, fortunaStore.DELAY)

        clearInterval(intervalStart)
    }
}

function fortunaData() {
    const parent = document.querySelector('.fortuna')
    if (!parent) return

    const popup = parent.closest('div')

    popup.style.background = 'rgba(255,255,255,0.75)'

    fetch(parent.getAttribute('action')).then(res => res.json()).then(data => {
        fortunaStore.other = data.otherField
        fortunaStore.spinAgain = data.spinAgain
        fortunaStore.fields = data.fields
        fortunaStore.FIELD_DEG = fortunaStore.CIRCLE_DEG / data.fields.length
    })
}

function giftsPresent(parent, mode = 'congrats') {
    const bg = parent.querySelector('.bg-wheel')
    const sendFormBtn = parent.querySelector('.send')

    if (mode === 'congrats') {
        bg.classList.add('bg-wheel--enable')
        bg.classList.remove('bg-wheel--disable')
        sendFormBtn.removeAttribute('style')
    } else if (mode === 'spin-again') {
        bg.classList.remove('bg-wheel--enable')
        bg.classList.add('bg-wheel--disable')
        sendFormBtn.setAttribute('style', 'display: none;')
    }
}

function spinner(wheel, rotate) {
    wheel.style = `transform: rotate(${rotate}deg);`
}

function sendFortunaForm(form) {
    try {

        const URL = form.getAttribute('action')
        const popupSuccess = {
            popup: document.querySelector('.popup-success-res'),
            title: document.querySelector('.popup-success-res').querySelector('[data-title]'),
            text: document.querySelector('.popup-success-res').querySelector('[data-text]'),
        }

        const giftStorage = {
            title: form.querySelector('[data-gift-title]'),
            text: form.querySelector('[data-gift-text]')
        }

        giftStorage.title.value = fortunaStore.GIFT.GIFT_BODY.title
        giftStorage.text.value = fortunaStore.GIFT.GIFT_BODY.text

        const inputs = form.querySelectorAll('input')
        fetch(URL, {
            method: "POST",
            body: formDataBuilder(inputs, form)
        }).then(res => res.json()).then(data => {
            if (data.status === 'success') {
                popupSuccess.popup.classList.add('res-success')
                popupSuccess.popup.classList.remove('res-error')
                popupSuccess.title.innerHTML = 'Спасибо за участи в акции!'
                popupSuccess.text.innerHTML = `
                Подарочный купон 
                \"<span class="info">${fortunaStore.GIFT.GIFT_BODY?.title} ${fortunaStore.GIFT.GIFT_BODY?.text}</span>\" был отправлен на указанную почту`
                $.fancybox.destroy()
                $.fancybox.open(popupSuccess.popup)
            } else {
                popupSuccess.popup.classList.remove('res-success')
                popupSuccess.popup.classList.add('res-error')
                popupSuccess.title.innerHTML = 'Ошибка!'
                popupSuccess.text.innerHTML = 'Подарочный купон не отправлен'
                $.fancybox.open(popupSuccess.popup)
            }
        })
    } catch (error) {
        console.log(error)
    }
}

function formDataBuilder(data, form) {
    let arr = []
    let formData = {}
    data.forEach(inp => {
        arr.push(inp.getAttribute('name'))
    })

    for (let i = 0; i < arr.length; i++) {
        let key = arr[i]
        let value = new FormData(form).get(arr[i])
        formData[key] = value
    }
    return JSON.stringify(formData)
}

function autoCallerFortunaModal() {
    const link = document.querySelector('[href="#popup-fortuna"]')
    if (!link) return
    link.dispatchEvent(new Event('click'))
}